import { AspectRatio, Box, Flex, Link } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import SectionHeader from './SectionHeader';

// Create motion components
const MotionFlex = motion(Flex);
const MotionBox = motion(Box);

export const VIDEOS_SUBTITLE = "From discussion panels to legal advice, Joe's got you covered.";

export const videoData = [
    {
        title: "Podcast Feature: Reasonable Doubt",
        videoId: "OChMwlhKV14",
    },
    // {
    //     title: "What to do when you accidentally shoplift",
    //     videoId: "dQw4w9WgXcQ",
    // },
    // {
    //     title: "How to handle a DUI checkpoint safely",
    //     videoId: "dQw4w9WgXcQ",
    // },
    // {
    //     title: "What to do if you're in a car accident",
    //     videoId: "dQw4w9WgXcQ",
    // },
];

interface VideoCardProps {
    title: string;
    videoId: string;
}

/**
 * A video with its title above it; the title opens the video on YouTube
 */
function VideoCard({ title, videoId }: VideoCardProps) {
    return (
        <Box
            height={"100%"}
            backgroundColor={"blue.400"}
            borderRadius={"xl"}
            overflow={"hidden"}
            boxShadow={"lg"}
        >
            {/* Title opens the video on YouTube */}
            <Link
                href={`https://www.youtube.com/watch?v=${videoId}`}
                isExternal
                display={"block"}
                paddingX={5}
                paddingY={4}
                fontFamily={"Montserrat"}
                fontWeight={600}
                fontSize={{ base: "md", md: "lg" }}
                color={"white.500"}
                transition={"color 0.2s ease"}
                _hover={{ textDecoration: "none", color: "yellow.100" }}
            >
                {title}
            </Link>

            <AspectRatio ratio={16 / 9}>
                <iframe
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title={title}
                    style={{ border: 0 }}
                    allow={"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"}
                    allowFullScreen
                    loading={"lazy"}
                />
            </AspectRatio>
        </Box>
    );
}

interface VideosProps {
    // Hide the section header when the page already has its own
    showHeader?: boolean;
}

// A single video is shown wide and centered; more than one go two per row on desktop
const videoWidth = videoData.length === 1
    ? { base: "100%", md: "800px" }
    : { base: "100%", md: "calc((100% - 24px) / 2)" };

export default function Videos({ showHeader = true }: VideosProps) {
    return (
        <Flex
            id={"#videos"}
            flexDirection="column"
            alignItems="center"
            gap={8}
            backgroundColor="blue.100"
            width="100%"
            paddingTop={showHeader ? 10 : 0}
            paddingBottom={10}
        >
            {/* Header */}
            {showHeader && (
                <MotionFlex
                    width="100%"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.5 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <SectionHeader
                        // Only used on the Resources page, as a subsection
                        size={"sm"}
                        title="Videos"
                        subtitle={VIDEOS_SUBTITLE}
                    />
                </MotionFlex>
            )}

            {/* Videos: a wrapping row so a partial last row is centered */}
            <Flex
                flexWrap="wrap"
                justifyContent="center"
                gap={6}
                width="90%"
                maxWidth="1200px"
            >
                {videoData.map((video, index) => (
                    <MotionBox
                        key={video.videoId}
                        width={videoWidth}
                        maxWidth="100%"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.5, delay: index * 0.1, ease: "easeOut" }}
                    >
                        <VideoCard title={video.title} videoId={video.videoId} />
                    </MotionBox>
                ))}
            </Flex>
        </Flex>
    );
}
